import { DataTool } from './DataTool'
import { COACHING_CAPACITY_TOOL_INSTRUCTIONS_URL } from '../../../constants/gvsuLinks'

interface Props {
  planOrganizationTaskId: number
  completed: boolean
  dueDate: Date
}
export const CoachingCapacityTool = (props: Props): JSX.Element => {
  return (
    <DataTool
      planOrganizationTaskId={props.planOrganizationTaskId}
      completed={props.completed}
      title='Coaching Capacity Tool'
      dueDate={props.dueDate}
      instructionsUrl={COACHING_CAPACITY_TOOL_INSTRUCTIONS_URL}
      color='var(--purple-500)'
      successMessage='Coaching Capacity Tool Updated'
      dataTestId='coachingCapacityTool'
    />
  )
}
